
import { defineComponent, nextTick } from 'vue';
import {
  CloseOutlined,
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons-vue';

export default defineComponent({
  name: 'PreviewImageModal',
  components: {
    CloseOutlined,
    LeftOutlined,
    RightOutlined
  },
  emits: ['after-close'],
  props: {
    images: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    isAttributeImg: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    // const className = this.isAttributeImg
    //   ? 'j-custom-close-fixed'
    //   : 'j-custom-close';
    const className = 'j-custom-close';
    return {
      width: 'calc(100% - 120px)', // this.isAttributeImg ? 1280 : 'calc(100% - 120px)',
      className,
      visible: true,
      imgSrcs: this.images.filter(s => s),
      showCloseBtn: false
    };
  },
  mounted() {
    setTimeout(() => {
      const closeBtn: any = document.querySelector('.ant-modal-close');
      if (closeBtn) {
        closeBtn.style.display = 'block';

        this.showCloseBtn = true;
      }
    }, 400);
  },
  methods: {
    handleClose() {
      const closeBtn: any = document.querySelector('.ant-modal-close');
      if (closeBtn) {
        this.showCloseBtn = false;
        closeBtn.style.display = 'none';
      }
      nextTick(() => {
        setTimeout(() => {
          this.visible = false;
        });
      });
    },
    handleAfterClose() {
      this.$emit('after-close');
    }
  }
});
